export default {
  'consumption.co2': 'Выброс CO2',
  'consumption.energy': 'Расход электроэнергии',
  'consumption.fuel': 'Расход топлива смешанный',
  'footnotes.local':
    'Данные по номинальной мощности и номинальному крутящему моменту указаны в соответствии с Директивой (ЕС) № 715/2007 в действующей редакции.',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Введите запрос / Код конфигурации',
  'search.result.buy-online': 'Сегодня в продаже',
  'search.results': 'Поиск не дал результатов | Найдено совпадений:  {count}',
  'search.results.count': 'Найдено совпадений:  {count}',
  'search.results.backup': 'Поиск не дал точных совпадений, результаты  ',
  'search.results.none.summary': 'К сожалению, поиск не дал результатов. Пожалуйста, попробуйте изменить запрос.',
  'search.show-more': 'Показать больше',
  'search.unavailable': 'К сожалению, в настоящее время поиск недоступен',
  'search.result.new': 'новый',

  'input.placeholder': 'Введите запрос / Код конфигурации',

  'suggestions.all_search_results': 'Все результаты поиска',
  'suggestions.all_search_results_for': 'Показать все результаты для',
  'suggestions.in': 'в',

  all: 'Все',
  UCOS: 'Интернет-магазин автомобилей с пробегом',
  PASSENGER_CARS: 'Легковые автомобили',
  VANS: 'Малотоннажные автомобили',
  NCOS: 'Интернет-магазин новых автомобилей',
  VIDEO: 'Видео',
  DEALER_LOCATOR: 'Поиск дилера',
  CONFIGURATOR: 'Конфигуратор автомобиля Mercedes-Benz',
  TEST_DRIVE: 'Тест-драйв',
  VEHICLE_SEARCH: 'Поиск автомобилей с пробегом',
  COLLECT: 'Коллекция и аксессуары',
  CONNECT: 'Магазин Mercedes me',

  'search.result.consumption': 'Расход',
  'watch.video': 'Смотреть видео',
  'input.recently': 'Недавно просмотренные',
  'input.help.title': 'Что вам нужно найти?',
  'input.help.text':
    'Поиск по типу автомобиля, модели, коду конфигурации или аксессуаров, другим продуктам и информации',

  'search.result.grid': 'Сетка',
  'search.result.list': 'Список',
};
